import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { Link } from 'react-router-dom'

type Campaign = {
  id: string
  name: string | null
  office: string | null
  county: string | null
  state: string | null
}

export default function Campaigns() {
  const [rows, setRows] = useState<Campaign[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      setError(null)

      // who am I?
      const { data: sess } = await supabase.auth.getSession()
      const uid = sess?.session?.user?.id
      if (!uid) { setRows([]); setLoading(false); return }

      // which campaigns am I in?
      const { data: links, error: linkErr } = await supabase
        .from('campaign_users')
        .select('campaign_id')
        .eq('user_id', uid)

      if (linkErr) { setError(linkErr.message); setLoading(false); return }
      const ids = (links ?? []).map(l => l.campaign_id).filter(Boolean)
      if (ids.length === 0) { setRows([]); setLoading(false); return }

      // fetch campaign details
      const { data: camps, error: campErr } = await supabase
        .from('campaigns')
        .select('id, name, office, county, state')
        .in('id', ids)

      if (campErr) setError(campErr.message)
      setRows((camps ?? []) as Campaign[])
      setLoading(false)
    }
    load()
  }, [])

  if (loading) return <div>Loading…</div>
  if (error) return <div style={{color:'crimson'}}>Error: {error}</div>

  return (
    <div>
      <h1>Campaigns</h1>
      {rows.length === 0 ? (
        <p>No campaigns found for your user.</p>
      ) : (
        <>
          <table cellPadding={6} style={{ borderCollapse:'collapse', width:'100%' }}>
            <thead>
              <tr>
                <th align="left">Name</th>
                <th align="left">Office</th>
                <th align="left">County</th>
                <th align="left">State</th>
                <th align="left">ID</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(c => (
                <tr key={c.id}>
                  <td>{c.name}</td>
                  <td>{c.office ?? ''}</td>
                  <td>{c.county ?? ''}</td>
                  <td>{c.state ?? ''}</td>
                  <td><code style={{fontSize:12}}>{c.id}</code></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginBottom: 12 }}>
            <Link to="/campaigns/new"><button>Create New Campaign</button></Link>
          </div>
        </>
      )}
    </div>
    
  )
}
